const sizeNumeric = {
  xSmall: 24,
  small: 32,
  xMedium: 40,
  medium: 48,
  large: 56
};
const size = {
  xSmall: `${sizeNumeric.xSmall}px`,
  small: `${sizeNumeric.small}px`,
  xMedium: `${sizeNumeric.xMedium}px`,
  medium: `${sizeNumeric.medium}px`,
  large: `${sizeNumeric.large}px`
};

export { size, sizeNumeric };
//# sourceMappingURL=size.js.map
